import React from 'react';
import { FormatterType } from '@components/Table/types';
import { avTooltipProps } from '@components/WithDescriptionTooltip/constants';
import { TooltipProps } from '@mui/material';
import { useAvContext } from '../../context/AvContextProvider';
import { FeatureFlags } from '../../types';
import { FieldTypes } from '../../views/Reports/types';
import DateOptions from './popupByType/DateOptions';
import DescriptionTooltip from './popupByType/DescriptionTooltip';
import { AllOptionsType, OptionalType } from './types';

const INITIAL_ENABLED_FIELD_TYPES_WITH_OPTIONS = new Set([FieldTypes.Measurement]);

interface BaseProps {
  enabledFieldTypesWithOptions?: Set<string | undefined>;
  tooltipProps?: Omit<TooltipProps, 'children'> & { id: `${string}-${string}-${string}-${string}-${string}` };
}

export type FieldOptionsProps = BaseProps & AllOptionsType & OptionalType;

export default function FieldOptions(props: FieldOptionsProps) {
  const { type, enabledFieldTypesWithOptions = INITIAL_ENABLED_FIELD_TYPES_WITH_OPTIONS, tooltipProps } = props;
  const { featureFlags } = useAvContext();

  if (enabledFieldTypesWithOptions.has(FieldTypes.Measurement) && (type === FieldTypes.Measurement || !type)) {
    return <DescriptionTooltip avTooltipProps={avTooltipProps} tooltipProps={tooltipProps} />;
  }

  if (
    featureFlags[FeatureFlags.DateDimBucket] &&
    enabledFieldTypesWithOptions.has(FormatterType.date) &&
    type === FormatterType.date &&
    props.selectedFields![props.field!.value]
  ) {
    return <DateOptions field={props.field} onApply={props.onApply} selectedFields={props.selectedFields} />;
  }

  return undefined;
}
